<template>
  <span
    class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
    :class="computedClass"
  >
        <slot />
    </span>
</template>

<script>
export default {
  name: 'Badge',

  props: {
    variant: {
      type: String,
      default: 'blue',
    }
  },

  computed: {
    computedClass() {
      return {
        gray: 'bg-gray-50 text-gray-600 ring-gray-300 dark:bg-gray-900 dark:bg-opacity-30',
        red: 'bg-red-50 text-red-700 ring-red-300 dark:bg-red-900 dark:text-red-800 dark:bg-opacity-30',
        yellow: 'bg-yellow-50 text-yellow-800 ring-yellow-300 dark:bg-yellow-900 dark:bg-opacity-30',
        green: 'bg-green-50 text-green-700 ring-green-300 dark:bg-green-700 dark:text-green-300 dark:bg-opacity-30',
        blue: 'bg-blue-50 text-blue-700 ring-blue-300 dark:bg-blue-900 dark:text-blue-800 dark:bg-opacity-30',
        indigo: 'bg-indigo-50 text-indigo-700 ring-indigo-300 dark:bg-indigo-900 dark:bg-opacity-30',
        purple: 'bg-purple-50 text-purple-700 ring-purple-300 dark:bg-purple-900 dark:bg-opacity-30',
        pink: 'bg-pink-50 text-pink-700 ring-pink-300 dark:bg-pink-900 dark:bg-opacity-30 dark:text-pink-800',
        plain: 'ring-transparent',
      }[this.variant]
    }
  }
}
</script>
